var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26786 2.44165C7.03766 1.10832 8.96216 1.10832 9.73196 2.44165L14.9955 11.5583C15.7653 12.8917 14.803 14.5583 13.2634 14.5583H2.73639C1.19678 14.5583 0.234531 12.8917 1.00433 11.5583L6.26786 2.44165Z",
    fill: "#ED3640"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M8.08771 9.81871C7.94904 9.81871 7.83704 9.77338 7.75171 9.68271C7.67171 9.59205 7.62104 9.46671 7.59971 9.30671L7.31971 6.89071C7.28238 6.61338 7.33304 6.38938 7.47171 6.21871C7.61038 6.04271 7.81571 5.95471 8.08771 5.95471C8.36504 5.95471 8.57038 6.04271 8.70371 6.21871C8.83704 6.38938 8.88504 6.61338 8.84771 6.89071L8.57571 9.30671C8.55438 9.46671 8.50371 9.59205 8.42371 9.68271C8.34371 9.77338 8.23171 9.81871 8.08771 9.81871ZM8.08771 11.7147C7.84771 11.7147 7.65571 11.6427 7.51171 11.4987C7.37304 11.3547 7.30371 11.1654 7.30371 10.9307C7.30371 10.7014 7.37304 10.5174 7.51171 10.3787C7.65571 10.2347 7.84771 10.1627 8.08771 10.1627C8.33838 10.1627 8.53038 10.2347 8.66371 10.3787C8.80238 10.5174 8.87171 10.7014 8.87171 10.9307C8.87171 11.1654 8.80238 11.3547 8.66371 11.4987C8.53038 11.6427 8.33838 11.7147 8.08771 11.7147Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.c9fa57fccaee15bed4d4ee00ca23e590.svg";
export { ForwardRef as ReactComponent };